import React, { FunctionComponent, useState } from 'react';
import { Button, IButtonProps } from '../button/button';
import styles from './download-with-image.module.scss';

export interface IDownloadWithImageProps {
  image: {
    url: string;
    description: string;
  };
  text: string;
  button: IButtonProps[];
}

export const DownloadWithImage: FunctionComponent<IDownloadWithImageProps> = props => {
  const { button, image, text } = props;
  const [mouseOver, setMouseOver] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.imageWrapper} ${mouseOver && styles.animated}`}>
        <img src={image.url} alt={image.description} />
      </div>
      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: text }}></div>
        <div
          className={styles.buttonWrapper}
          onMouseEnter={(): void => setMouseOver(true)}
          onMouseLeave={(): void => setMouseOver(false)}
        >
          {button.map((item, i) => (
            <Button {...item} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};
